module.exports = __webpack_public_path__ + "static/media/videoOutline.1ab28007.svg";